import { DeclarationType, Settings } from '../model/Model';

export interface CheckinForm {
    name: string,
    company: string,
    phone: string,
    rememberMe: boolean,
    declaration?: string,
    contact?: number,
    activity?: number
}

export type CheckinFormNames = 'name' | 'company' | 'phone' | 'rememberMe' | 'declaration' | 'contact' | 'activity'

export enum Step {
    DETAILS,
    RULES,
    CONTACT,
    ACTIVITY,
    DECLARATION,
    DONE
}

export const isLastPage = (settings: Settings, step: Step) => {
    const { siteRules, siteActivities, declaration, siteContacts } = settings;
    switch (step) {
        case Step.DETAILS:
            return declaration !== DeclarationType.SEPARATE && !siteRules && !siteContacts && !siteActivities;
        case Step.RULES:
            return declaration !== DeclarationType.SEPARATE && !siteContacts && !siteActivities;
        case Step.CONTACT:
            return declaration !== DeclarationType.SEPARATE && !siteActivities;
        case Step.ACTIVITY:
            return declaration !== DeclarationType.SEPARATE;
        case Step.DECLARATION:
            return true;
    }
    return false;
}

export const chooseNextStep = (settings: Settings, step: Step): Step => {
    switch (step) {
        case Step.DETAILS:
            if (settings?.siteRules) {
                return Step.RULES;
            }
            if (settings?.siteContacts) {
                return Step.CONTACT;
            }
            if (settings?.siteActivities) {
                return Step.ACTIVITY;
            }
            if (settings?.declaration === DeclarationType.SEPARATE) {
                return Step.DECLARATION;
            }
            break;
        case Step.RULES:
            if (settings?.siteContacts) {
                return Step.CONTACT;
            }
            if (settings?.siteActivities) {
                return Step.ACTIVITY;
            }
            if (settings?.declaration === DeclarationType.SEPARATE) {
                return Step.DECLARATION;
            }
            break;
        case Step.CONTACT:
            if (settings?.siteActivities) {
                return Step.ACTIVITY;
            }
            if (settings?.declaration === DeclarationType.SEPARATE) {
                return Step.DECLARATION;
            }
            break;
        case Step.ACTIVITY:
            if (settings?.declaration === DeclarationType.SEPARATE) {
                return Step.DECLARATION;
            }
            break;
        case Step.DECLARATION:
            break;
    }
    return Step.DONE
}
